import AdminApi from '../../apis/admin_api';
import { useQuery } from '@tanstack/react-query';
import AppLayout from '../../components/AppLayout';
import ShowPending from '../../components/ShowPending';
import ShowError from '../../components/ShowError';
import AdminReportTable from '../../components/AdminReportTable';
import { useSearchParams } from 'react-router';
import AdminDaysSince from '../../components/AdminDaysSince';
// import { faker } from '@faker-js/faker';
// import { format } from 'date-fns';
// import AlpacaApi from '../../apis/alpaca_api';

export default function AdminPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const since = searchParams.get('since') || '';
  const { data, isPending, error, isError } = useQuery({
    queryKey: ['adminData', since],
    queryFn: async () =>
      await AdminApi.getAdminData(since ? parseInt(since) : undefined),
  });

  // const createAlpacas = async () => {
  //   for (let index = 0; index < 20; index++) {
  //     const alpaca = {
  //       active: true,
  //       alpacaId: 0,
  //       applicationUserId: '93605290-4249-4491-8ac5-c43835a90f4d',
  //       name: faker.person.fullName(),
  //       dateOfBirth: format(faker.date.birthdate(), 'yyyy-MM-dd'),
  //       colorId: 3,
  //       genderId: 1,
  //       breedId: 1,
  //       registryNumber: null,
  //       farmId: 97,
  //       microchipId: null,
  //       microchipLocation: null,
  //       note: null,
  //       tagNumber: null,
  //     };

  //     await AlpacaApi.createAlpaca(alpaca);
  //   }
  // };
  return (
    <AppLayout>
      <div className='text-center'>
        <h3 className='text-center text-2xl dark:text-gray-300 mb-1'>Admin</h3>
        <p className='mb-2'>initial 04/19/2026</p>
      </div>
      {/* <button onClick={createAlpacas}>click</button> */}
      <AdminDaysSince since={since} setSince={setSearchParams} />
      <ShowPending isPending={isPending} />
      <ShowError isError={isError} error={error} />
      {data && <AdminReportTable data={data} />}
    </AppLayout>
  );
}
